
export class FileShareItemResyncModel {
  ip: string;
  serverName: string;
  shareName: string;
  path: string;
  isDirectory: boolean;
  plannedDate: Date|null;
}
